import React from 'react';
import cx from 'classnames';
import './PortholeImage.css';

type PorthomeImageProps = {
  className?: string;
  alt?: string;
  src: string;
};

export const PortholeImage = ({ className, alt = '', src }: PorthomeImageProps): JSX.Element => {
  const classes = cx('zola-ui', 'pre-auth-porthole-image', className);

  return (
    <div className={classes}>
      <div className="porthole-img__container">
        <img src={src} alt={alt} className="porthole-img" loading="lazy" />
      </div>
    </div>
  );
};

export default PortholeImage;
